import { ChevronDown } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { cn } from '@/lib/utils';

export function WorkspaceSelector({ className }: { className?: string }) {
  const { user, isImpersonating } = useAuth();
  if (!user?.workspaceName) return null;

  return (
    <button
      type="button"
      className={cn(
        'inline-flex h-11 max-w-[220px] items-center gap-2 rounded-pill border border-card-stroke bg-frame px-3.5 text-[13px] text-fg',
        'hover:bg-card-soft transition-colors duration-fast',
        className,
      )}
    >
      <span
        className={cn(
          'h-2 w-2 shrink-0 rounded-sm',
          isImpersonating ? 'bg-butter-deep' : 'bg-mint-deep',
        )}
      />
      <span className="truncate font-medium">{user.workspaceName}</span>
      <span className="font-mono text-[11px] text-fg-muted shrink-0">
        {isImpersonating ? 'IMP' : 'WS'}
      </span>
      <ChevronDown className="h-3.5 w-3.5 text-fg-muted" strokeWidth={1.8} />
    </button>
  );
}
